import { Card, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import '@features/Incentive/incentive.css';
import { DashboardSelector } from '../store/DashboardSelector';
import { useEffect, useMemo } from 'react';
import { GetTransactionDashboard } from '../business/DashboardBusiness';
import { TransactionBoxStatus, TransactionStatus } from 'common/constants';
export const TransactionPickupDashboard = () => {
  const dispatch = useDispatch();
  const dashboardState = useSelector(DashboardSelector);
  const data = useMemo(
    () => dashboardState.TransactionPickupDashboardList || [],
    [dashboardState.TransactionPickupDashboardList]
  );

  const columns = [
    {
      title: 'Reference no.',
      dataIndex: 'RefNo',
      key: 'RefNo',
    },
    {
      title: 'Name',
      dataIndex: 'CompleteName',
      key: 'CompleteName',
    },
    {
      title: 'Contact no.',
      dataIndex: 'ContactNo',
      key: 'ContactNo',
    },
    {
      title: 'Address',
      dataIndex: 'CompleteAddress',
      key: 'CompleteAddress',
    },
    {
      title: 'Pickup date',
      dataIndex: 'Date',
      key: 'Date',
      sorter: (a, b) => a.Date.localeCompare(b.Date),
    },
    {
      title: 'No. of boxes',
      dataIndex: 'Qty',
      key: 'Qty',
      sorter: (a, b) => a.Qty.localeCompare(b.Qty),
    },

    {
      title: 'Created date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      sorter: (a, b) => a.CreatedDate.localeCompare(b.CreatedDate),
    },
  ];
  useEffect(() => {
    const fetchData1 = async () => {
      await dispatch(GetTransactionDashboard(TransactionStatus.PI));
    };

    fetchData1();
  }, [dispatch]);

  return (
    <div className="App">
      <Card>
        <Table dataSource={data} columns={columns} pagination={{ pageSize: 100 }} />
      </Card>
    </div>
  );
};
